import { ReactNode, useMemo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Flex, Stepper, useScreenResolution } from "dash-ui";

import Footer from "flow-components/Footer/Footer";
import Header from "flow-components/Header/Header";

const Container = styled(Flex)`
  margin-top: 56px;
  align-self: center;
  width: 100%;
  min-height: calc(100vh - 110px);
  @media ${({ theme }) => theme.devices.mobile} {
    min-height: calc(100vh - 160px);
  }
`;

function CompleteSignUpPageLayout({
  children,
  withProfileDropdown,
  withLogoutButton,
  activeStep,
}: {
  children: ReactNode;
  activeStep: number;
  withProfileDropdown?: boolean;
  withLogoutButton?: boolean;
}) {
  const { t } = useTranslation(["common", "pages"]);
  const { devices } = useScreenResolution();

  const steps = useMemo(
    () => [
      { label: t("common:labels:verifyAccount"), value: "account" },
      {
        label: devices.isMobile
          ? t("pages:completeSignUp:additionalShortLabel")
          : t("pages:completeSignUp:additionalLabel"),
        value: "additionalLabel",
      },
      { label: t("pages:completeSignUp:pickPlan"), value: "pickPlan" },
      {
        label: devices.isMobile
          ? t("pages:completeSignUp:setupSubscriptionShortLabel")
          : t("pages:completeSignUp:setupSubscriptionLabel"),
        value: "setupSubscription",
      },
    ],
    [devices, t]
  );

  return (
    <Flex
      flex={1}
      flexDirection="column"
      alignItems="inherit"
      minHeight="100vh">
      <Header
        withProfileDropdown={withProfileDropdown}
        withLogoutButton={withLogoutButton}
      />
      <Container
        maxWidth={activeStep === 2 ? 1100 : 900}
        flex={1}
        px={4}
        flexDirection="column">
        <Flex w="100%" mt={6}>
          <Stepper steps={steps} activeStep={activeStep} />
        </Flex>
        <Flex w="100%" flex={1}>
          {children}
        </Flex>
      </Container>
      <Footer variation="light" withSidebar={false} />
    </Flex>
  );
}

export default CompleteSignUpPageLayout;
